export const reportTypes = {
  GET_PREVIEW_APPLY_CASES: 'GET_PREVIEW_APPLY_CASES',
  GET_SUMMRY_APPLY_CASES: 'GET_SUMMRY_APPLY_CASES',
  GET_List_APPLY_CASES: 'GET_List_APPLY_CASES',
};
